import { render, staticRenderFns } from "./PeriodSpecifications.vue?vue&type=template&id=236037fd"
import script from "./PeriodSpecifications.vue?vue&type=script&lang=js"
export * from "./PeriodSpecifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports